var map = {
	"./7z.svg": "15a6",
	"./aac.svg": "36f1",
	"./ai.svg": "87f7",
	"./archive.svg": "7f12",
	"./arj.svg": "5ad4",
	"./audio.svg": "2da9",
	"./avi.svg": "faf7",
	"./css.svg": "0aa8",
	"./csv.svg": "65ef",
	"./dbf.svg": "2aba8",
	"./doc.svg": "892f",
	"./dwg.svg": "799c",
	"./exe.svg": "70ea",
	"./fla.svg": "9830",
	"./flac.svg": "be4b",
	"./gif.svg": "76ce",
	"./html.svg": "701a",
	"./iso.svg": "6c54",
	"./jpg.svg": "588b",
	"./js.svg": "d1c6",
	"./json.svg": "ccc0",
	"./mdf.svg": "713c",
	"./mp2.svg": "9ec1",
	"./mp3.svg": "337f",
	"./mp4.svg": "90cb",
	"./mxf.svg": "af52",
	"./nrg.svg": "acd0",
	"./pdf.svg": "090b",
	"./png.svg": "7bff",
	"./ppt.svg": "b012",
	"./psd.svg": "e22d",
	"./rar.svg": "3056",
	"./rtf.svg": "33c8",
	"./svg.svg": "c1a0",
	"./text.svg": "0c0a",
	"./tiff.svg": "42f8",
	"./txt.svg": "43d4",
	"./unknown.svg": "aad1",
	"./video.svg": "356d",
	"./wav.svg": "2acb",
	"./wma.svg": "d99c",
	"./xls.svg": "96f6",
	"./xml.svg": "a3a4",
	"./zip.svg": "7a77a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "005d";